export default __webpack_public_path__ + "static/media/quotes-right.68804796.svg";